import { combineReducers } from "redux";
import productReducer from "pages/Products/reducer";
import categoriesReducer from "pages/Categories/reducer";
import alertReducer from "containers/Toast/slice";
import authReducer from "pages/Admin/Auth/reducer";

export default combineReducers({
  auth: authReducer,
  products: productReducer,
  categories: categoriesReducer,
  alerts: alertReducer,
});
